export class Validation {
  constructor() {
    this._validation = document.querySelectorAll('[data-validation]');
    this._language = document.documentElement.lang;

    this._onSubmitForm = this._onSubmitForm.bind(this);

    this._emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    this._errors = new Set();

    this._textDictionary = {
      ru: {
        required: 'Заполните все обязательные поля',
        phone: 'Введите пожалуйста корректный номер телефона',
        email: 'Введите пожалуйста корректный адрес электронной почты',
      },
      en: {
        required: 'Fill in all required fields',
        phone: 'Please enter the correct phone number',
        email: 'Please enter the correct email address.',
      },
    };
  }

  init() {
    if (!this._validation.length) {
      return;
    }

    this._validation.forEach((element) => {
      const form = element.querySelector('[data-validation-form]');

      form.addEventListener('submit', this._onSubmitForm);
    });
  }

  _onSubmitForm(evt) {
    evt.preventDefault();
    const errors = evt.target.querySelector('[data-validation-errors]');

    errors.classList.remove('is-error');
    errors.innerHTML = '';

    this._validateForm(evt.target);

    if (this._errors.size) {
      evt.preventDefault();

      this._setErrors(errors);
      errors.classList.add('is-error');
    } else {
      const recaptchaToken = evt.target.querySelector('[data-recaptcha-token]');

      grecaptcha.execute('6Lda0FsrAAAAAHbFFODff97wK2WeWaw1YDlkZ6Us', {
        action: 'submit',
      })
        .then(function (token) {
          recaptchaToken.value = token;
          evt.target.submit();
        });
    }
  }

  _validateForm(form) {
    this._errors.clear();

    const fields = form.querySelectorAll('[data-validate-type]');

    fields.forEach((field) => {
      const type = field.dataset.validateType;

      switch (type) {
        case 'text':
          this._validateTextField(field);
          break;
        case 'phone':
          this._validatePhoneField(field);
          break;
        case 'email':
          this._validateEmailField(field);
          break;
      }
    });
  }

  _validateTextField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validatePhoneField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateEmailField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (input.value && !this._emailRegex.test(input.value)) {
      field.classList.add('is-error');
      this._errors.add('email');
    } else {
      field.classList.remove('is-error');
    }
  }

  _setErrors(element) {
    let result = '';

    this._errors.forEach((error, errorAgain, set) => {
      switch (error) {
        case 'required':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
        case 'phone':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
        case 'email':
          result += this._createError(this._textDictionary[this._language][error]);
          break;
      }
    });

    element.innerHTML = result;
  }

  _createError(text) {
    return `
      <div class="auth-page__error">
				<svg width="20" height="20" aria-hidden="true">
					<use xlink:href="#icon-error-2"></use>
				</svg>
				<span>${text}</span>
			</div>
    `;
  }
}
